import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'actions';
import TextArea from '../../../components/Admin/Settings/TextArea'
import _ from 'lodash';
import InputField from 'components/InputField/InputField';
import Icon from 'material-ui/Icon';
import FileField from 'components/InputField/FileField'
import shortid from 'shortid';
import { toast } from 'react-toastify';


const {
  loadLandingDataSaga,
  createLandingDataSaga,
  loadAboutDataSaga,
  createAboutDataSaga
} = actions;

class Settings extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      landingData: '',
      aboutData: {}
    }
  }

  componentWillMount = () => {
    this.loadLandingData();
    this.loadAboutData();
    this.setState({
      landingData: this.props.landingData,
      aboutData: this.props.aboutData
    })
  }

  componentWillReceiveProps(props) {
    if (!_.isEqual(this.state.landingData, props.landingData))
      this.setState({
        landingData: props.landingData
      });
    if (!_.isEqual(this.state.aboutData, props.aboutData))
      this.setState({
        aboutData: props.aboutData
      });
  }

  loadLandingData = () => this.props.loadLandingData()
  loadAboutData = () => this.props.loadAboutData()

  handleChangeTopic = (value) => {
    this.setState({ landingData: value })
  }

  handleChangeAboutBody = (value) => {
    const aboutData = this.state.aboutData
    this.setState({
      aboutData: {
        ...aboutData,
        ...{
          body: value
        }
      }
    })
  }

  handleChangeAboutFooter = (value) => {
    const aboutData = this.state.aboutData
    this.setState({
      aboutData: {
        ...aboutData,
        ...{
          footer: value
        }
      }
    })
  }

  handleTitleSubmit = () => {
    this.props.createLandingData(this.state.landingData)
  }

  handleAboutSubmit = () => {
    const aboutData = this.state.aboutData
    let data = new FormData();

    data.append(`[abouts][body]`, aboutData.body)
    data.append(`[abouts][footer]`, aboutData.footer)

    this.props.createAboutData(data)
  }

  handleFoundersSubmit = () => {
    const founders = this.state.aboutData.founders.filter(e => !!e.name);
    let data = new FormData();

    if (founders && founders.length)
      founders.forEach(founder => {
        if (founder.id)
          data.append('abouts[founders_attributes[]][id]', founder.id);
        if (founder._destroy)
          data.append('abouts[founders_attributes[]][_destroy]', founder._destroy);
        if (typeof founder.avatar.url != 'string' && founder.avatar)
          data.append('abouts[founders_attributes[]][avatar]', founder.avatar);
        if (typeof founder.avatar.url == 'string' && founder.avatar)
          data.append('abouts[founders_attributes[]][avatar]', founder.avatar.url);
        data.append('abouts[founders_attributes[]][name]', founder.name);
      })

    this.props.createAboutData(data)
    setTimeout(() => { this.loadAboutData(); }, 2000)
  }

  onFounderAdd = () => {
    let founders = this.state.aboutData.founders.slice();
    if (founders.length >= 7) {
      toast.success('Only 7 items are alowed.')
      return false
    }
    this.setState({
      aboutData: {
        ...this.state.aboutData,
        ...{
          founders: [
            ...this.state.aboutData.founders,
            ...[{ name: '', avatar: '', __id: shortid.generate() }]
          ]
        }
      }
    });
  }

  onFounderRemove = (index, __id) => {
    let founders = this.state.aboutData.founders.slice();
    const founder = founders[index]
    if (founder.id) {
      this.onFounderChange(index, '_destroy', true)
      this.handleFoundersSubmit()
    } else {
      founders = founders.filter(founder => founder.__id != __id);
      this.setState({
        aboutData: {
          ...this.state.aboutData,
          ...{
            founders: founders
          }
        }
      });
    }
  }

  onFounderChange = (index, field, value) => {
    let founders = this.state.aboutData.founders.slice();
    let founder = founders[index];
    founder[field] = value;
    this.setState({
      aboutData: {
        ...this.state.aboutData,
        ...{
          founders: founders
        }
      }
    });

  }


  render() {
    const {
      handleChangeTopic,
      handleTitleSubmit,
      handleAboutSubmit,
      handleChangeAboutBody,
      handleChangeAboutFooter,
      onFounderAdd,
      onFounderRemove,
      onFounderChange,
      handleFoundersSubmit
    } = this;
    return (
      <main className="site--width clearfix container_statistics container_admin_settings">
        <div>
          <h2>General Settings</h2>
        </div>
        <div>
          <TextArea title='Landing page title' hadleSubmit={handleTitleSubmit} setQuillRef={this.setQuillRef} value={this.state.landingData} handleChange={handleChangeTopic} />
        </div>
        <div className='mt-20'>
          <TextArea title='About page body' hadleSubmit={handleAboutSubmit} setQuillRef={this.setQuillRef} value={this.state.aboutData.body} handleChange={handleChangeAboutBody} />
        </div>
        <div className='mt-20'>
          <TextArea title='About page footer' hadleSubmit={handleAboutSubmit} setQuillRef={this.setQuillRef} value={this.state.aboutData.footer} handleChange={handleChangeAboutFooter} />
        </div>
        <div className='mt-20'>
          <h3>Founders list:</h3>
          <div className="section_form_add_expert" >
            <h3>Add + </h3>
            {this.state.aboutData.founders && this.state.aboutData.founders.map((founder, index) => (
              <div className="add_expert_row" key={founder.__id}>
                <h5>Founder {index + 1}</h5>
                <Icon onClick={() => onFounderRemove(index, founder.__id)} className="remove_expert">close</Icon>
                <InputField
                  className='s12'
                  label='Founder name'
                  field_name='name'
                  onChange={(e) => (onFounderChange(index, 'name', e.target.value))}
                  value={founder.name}
                />
                <FileField
                  className=' s12'
                  field_name="avatar"
                  onChange={(e) => (onFounderChange(index, 'avatar', e.target.value))}
                  label='Founder avatar'
                />

              </div>
            ))}
            <a className="add_option" onClick={onFounderAdd} href="javascript:void(0)">
              Add another option
            </a>
          </div>
          <button className='button_classic mt-20' type='button' onClick={() => handleFoundersSubmit()}>
            Save
          </button>
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    landingData: state.landingData.body,
    aboutData: state.landingData.about_us,
    isLoaded: state.landingData.isLoaded
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    loadLandingData: () => dispatch(loadLandingDataSaga()),
    createLandingData: (data) => dispatch(createLandingDataSaga(data)),
    loadAboutData: () => dispatch(loadAboutDataSaga()),
    createAboutData: (data) => dispatch(createAboutDataSaga(data))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);



// WEBPACK FOOTER //
// ./src/containers/Admin/Settings/Settings.jsx